import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  const quickLinks = [
    { path: '/', label: t('nav.home') },
    { path: '/about', label: t('nav.about') },
    { path: '/services', label: t('nav.services') },
    { path: '/contact', label: t('nav.contact') },
  ];

  const serviceLinks = [
    { label: t('service.mechanical.name'), path: '/services' },
    { label: t('service.electricity.name'), path: '/services' },
    { label: t('service.hydraulic.name'), path: '/services' },
    { label: t('service.hvac.name'), path: '/services' },
    { label: t('service.tickets.name'), path: '/services' },
    { label: t('service.tourism.name'), path: '/services' },
  ];

  return (
    <footer className="bg-primary-950 text-background-200">
      <div className="w-full px-4 md:px-6 lg:px-10 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <img
                src="https://storage.helloreaddy.io/project_files/92e1f7d8-4b49-4026-a33b-e8c282efe1cd/e044e290-bfd7-421d-a771-db88820eaff2_compressed__client-DeiaSpart.webp"
                alt="DEIASPART"
                className="h-8 w-auto object-contain brightness-0 invert"
              />
            </div>
            <p className="text-sm text-background-300 leading-relaxed mb-4">
              {t('home.about.text1').substring(0, 120)}...
            </p>
            <div className="flex items-center gap-2 text-sm text-background-300">
              <i className="ri-map-pin-line w-4 h-4 flex items-center justify-center"></i>
              <span>{t('footer.address')}</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm uppercase tracking-wider">
              {t('footer.links')}
            </h4>
            <ul className="space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-background-300 hover:text-accent-400 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm uppercase tracking-wider">
              {t('footer.services')}
            </h4>
            <ul className="space-y-2.5">
              {serviceLinks.map((link, i) => (
                <li key={i}>
                  <Link
                    to={link.path}
                    className="text-sm text-background-300 hover:text-accent-400 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm uppercase tracking-wider">
              {t('nav.contact')}
            </h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2.5">
                <div className="w-8 h-8 rounded-lg bg-primary-900 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-phone-line text-accent-400 w-4 h-4 flex items-center justify-center"></i>
                </div>
                <div className="text-sm text-background-300">
                  <p>222 744 200</p>
                  <p>923 392 218</p>
                  <p>934 765 583</p>
                </div>
              </li>
              <li className="flex items-start gap-2.5">
                <div className="w-8 h-8 rounded-lg bg-primary-900 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-mail-line text-accent-400 w-4 h-4 flex items-center justify-center"></i>
                </div>
                <div className="text-sm text-background-300">
                  <p>geral@deiaspart.co.ao</p>
                  <p>rodrigo.deia@deiaspart.co.ao</p>
                </div>
              </li>
              <li className="flex items-center gap-2.5">
                <div className="w-8 h-8 rounded-lg bg-primary-900 flex items-center justify-center shrink-0">
                  <i className="ri-file-text-line text-accent-400 w-4 h-4 flex items-center justify-center"></i>
                </div>
                <span className="text-sm text-background-300">{t('footer.nif')} 5417635634</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-10 pt-6 border-t border-primary-900 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400">
            © {new Date().getFullYear()} {t('footer.rights')}
          </p>
          <a
            href="https://sysadmin.it.ao"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="text-xs text-background-400 hover:text-accent-400 transition-colors"
          >
            {t('footer.developedBy')} <b>SYSADMIN-T.I, LDA.</b>
          </a>
        </div>
      </div>
    </footer>
  );
}